import React from "react";
import useGetOrder from "../../hooks/queries/useGetOrder";

const TrackingIndex = [
  {
    title: "Order Placed",
    step: "pending",
  },
  {
    title: "Price Quoted",
    step: "reviewed",
  },
  {
    title: "Payment",
    step: "paid",
  },
  {
    title: "3D Model Designing",
    step: "processing",
  },
  {
    title: "Completed",
    step: "completed",
  },
];

const Track = () => {
  const [orderId, setOrderId] = React.useState(null);
  const [oid, setOid] = React.useState("");
  const order = useGetOrder(orderId);
  const handleTrack = () => {
    console.log("tracking", oid);
    setOrderId(oid);
  };
  return (
    <section className="p-8 text-white text-left">
      <p className="text-5xl font-bold mb-6">Track Order</p>
      <div className="flex flex-col">
        <span class="text-xl mb-3">Order Id</span>
        <input
          label="FName"
          className="input input-bordered bg-[#1B1C2D] w-96"
          placeholder="Order Id e.g. #973409734"
          onChange={(e) => {
            setOid(e.target.value);
          }}
        />
        <button
          type="submit"
          className="secondary-button w-48 mt-6"
          onClick={handleTrack}
        >
          Track
        </button>
        <div className="discount-card flex flex-col my-8 justify-center text-center">
          <p className="text-4xl font-bold my-6">Order Details</p>
          <ul class="steps my-8">
            {TrackingIndex.map((item, index) => {
              return (
                <li
                  className={`step ${
                    order?.data?.status === item.step && "step-accent"
                  }`}
                >
                  {item.title}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Track;
